import styled, { css } from 'styled-components';
import NextImage from 'next/image';

export const Wrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        min-height: 20rem;

        @media ${theme.breakpoints.large.media} {
            min-height: 35rem;
        }
    `}
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Heading = styled.h1`
    ${({ theme }) => css`
        font-family: ${theme.fonts.secondary};
        color: ${theme.colors.primary.hex};
        text-transform: uppercase;
        font-size: 1.875rem;
        font-weight: 900;
        line-height: 1.05;
        margin: 4rem 0 0;

        @media ${theme.breakpoints.medium.media} {
            font-size: 3rem;
            margin-top: 2.25rem;
        }

        @media ${theme.breakpoints.large.media} {
            margin-top: 10rem;
        }

        @media ${theme.breakpoints.xlarge.media} {
            margin-top: 7.8rem;
            font-size: 5rem;
        }
    `}
`;

export const PostHeading = styled.p`
    ${({ theme }) => css`
        font-family: ${theme.fonts.secondary};
        font-weight: 300;
        margin-top: 1rem;
        font-size: 1.375rem;
        line-height: 1.1;

        @media ${theme.breakpoints.small.media} {
            max-width: 16.6rem;
        }

        @media ${theme.breakpoints.medium.media} {
            max-width: 100%;
            margin-top: 1.5rem;
            font-size: 1.75rem;
        }

        @media ${theme.breakpoints.xlarge.media} {
            font-size: 2.25rem;
        }
    `}
`;

export const StyledNextImageDesktop = styled(NextImage)`
    ${({ theme }) => css`
        position: relative;
        z-index: -1;
        display: none;
        object-fit: cover;

        @media ${theme.breakpoints.mediumSmall.media} {
            display: block;
        }
    `}
`;

export const StyledNextImageDevice = styled(NextImage)`
    ${({ theme }) => css`
        position: relative;
        z-index: -1;
        display: block;
        object-fit: cover;

        @media ${theme.breakpoints.mediumSmall.media} {
            display: none;
        }
    `}
`;
